<template>
  <div class="container">
    <Title-b title="自提點查詢" />
    <div class="all">
      <div class="from">
        <div>
          <span class="span">自提點篩選：</span>
          <i-select
            v-model="addressid.Country"
            placeholder="請選擇國家"
            @on-change="changeAddress('Country', $event)"
            style="width: 105px"
          >
            <i-option
              :value="itemm.CountryID"
              v-for="(itemm, indexx) in syck"
              :key="indexx"
            >
              {{ itemm.CountryName }}
            </i-option>
          </i-select>
          &nbsp;
          <i-select
            v-model="addressid.Provice"
            placeholder="請選擇省"
            @on-change="changeAddress('Provice', $event)"
            style="width: 105px"
          >
            <i-option
              :value="itemm.CodeID"
              v-for="(itemm, indexx) in addList.Country"
              :key="indexx"
            >
              {{ itemm.Name }}
            </i-option>
          </i-select>
          &nbsp;
          <!-- 第二个 -->
          <i-select
            v-model="addressid.City"
            placeholder="請選擇市"
            @on-change="changeAddress('City', $event)"
            style="width: 105px"
          >
            <i-option
              :value="item.CodeID"
              v-for="(item, index) in addList.Provice"
              :key="index"
            >
              {{ item.Name }}
            </i-option>
          </i-select>
          &nbsp;
          <!-- 第三个 -->
          <i-select
            v-model="addressid.Area"
            placeholder="請選擇"
            @on-change="changeAddress('Area', $event)"
            style="width: 105px"
          >
            <i-option
              :value="itemmm.CodeID"
              v-for="(itemmm, indexxx) in addList.City"
              :key="indexxx"
            >
              {{ itemmm.Name }}
            </i-option>
          </i-select>
          &nbsp;
        </div>
      </div>
      <div class="search">
        <i-input
          placeholder=""
          v-model="searchValue"
          style="width: 343px"
        ></i-input>
        <i-button
          type="error"
          class="search_error"
          @click="GetAllZtd"
          style="color: #fff"
          >自提點查詢</i-button
        >
        <img src="../../../assets/images/sousuo1.png" alt="" />
      </div>
      
      <div class="address-wrapper">
        <div
          class="address-item"
          v-for="(item, index) in allorder"
          :key="index"
        >
          <div class="a-link">
            <img class="a-img" src="@/assets/images/dizhzi.png" alt="" />
            {{ item.Name }}
          </div>
          <div class="a-title">{{ item.Address }}</div>
          <!-- <div class="a-address">{{item.Address}}</div> -->
          <div>
            聯絡人：{{ item.link_man }}
            <span class="a-tel">聯絡電話：{{ item.Tel }}</span
            ><span class="a-tel">聯系手機：{{ item.Phone }}</span>
          </div>
          <div class="a-time">營業時間：{{ item.Business_time }}</div>
          <div>
            最大限重：{{ item.MaxWeight }} , 是否支持到付：
            {{ item.IsDfDescption }}
          </div>
          <div class="a-zhu">
            注：{{item.Memo}}
          </div>
        </div>
      </div>
      <!-- <div>
        <h1 style="color: #e95098;margin-top:15px">注：15公斤或以上須即天取 過期倉費: 每份件每日$10 (如分單3件或3紮,將收取$10x3)</h1>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      allorder: [],
      arr: [],
      searchValue: "",
      addList: {
        Provice: [],
        City: [],
        Area: [],
        Country: [],
      },
      addressid: {
        Country: 0,
        Provice: 0,
        City: 0,
        Area: 0,
      },
      syck: [],
    };
  },
  methods: {
    async getCountryList() {
      const params = { MemberID: localStorage.getItem("userID") };
      const { data } = await this.$post("GetCountryList", params);
      if (data.State) {
        this.syck = JSON.parse(data.ReturnJson);
      }
    },
     async GetAllZtd2() {
      const { data } = await this.$post("QueryZtd", this.addressid);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson).ZtdInfo;
      }
    },
    // 省市区
    async changeAddress(key, e) {
      switch (key) {
        case "Country":
          this.addList.Provice = [];
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.Provice = 0;
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "Provice":
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "City":
          this.addList.Area = [];
          this.addressid.Area = 0;
          break;
      }
      this.addressid[key] = e;
      const params = {
        ParentID: key == "Country" ? 0 : e,
        CountryID: this.addressid.Country,
      };
      this.GetAllZtd2()
      const { data } = await this.$post("GetAreaByParentID", params);
      if (data.State) {
        this.addList[key] = JSON.parse(data.ReturnJson);
      }
    },
    async GetAllZtd() {
      let _this = this;
      const { data } = await this.$post("GetAllZtd", {
        ZtdName: this.searchValue,
        "Country":86,"Provice":"1","City":0,"Area":0
      });
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
      }
    },
  },
  mounted() {
    this.getCountryList();
    this.GetAllZtd();
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 1069px;
  height: 748px;
  background: #fff;
  padding: 20px 29px;
  .from { 
    // margin: 20px auto 50px;
    margin: 27px 0 0 0px
  }
  .address-wrapper {
    margin-top: 26px;
    overflow: auto;
    height: 500px;
    // height: 380px;
    // border-bottom: 2px solid #e95098;
    border: 1px solid#515a6e4f;
    padding: 10px 0;
    .address-item {
      padding: 0px 0 0 20px;
      margin-bottom: 20px;
      display: inline-block;
      /* vertical-align: top; */
      width: 47%;
      /* height: 160px; */
      line-height: 26px;
      border: 2px solid #333;
      margin: 0 0 20px 10px;
      // padding: 0 0 0 15px;
      // margin-bottom: 20px;
      // display: inline-block;
      // vertical-align: top;
      // width: 50%;
      // line-height: 26px;
      .a-title {
        @include color($_color);
        font-size: 16px;
        font-weight: bold;
        height: 42px;
      }
      .a-time{
        height: 30px;
      }
      .a-address {
        font-size: 16px;
      }
      .a-tel {
        @include color($_color);
        margin-left: 20px;
      }
      .a-link {
        // @include color($_color);
        color: #c850e9;
        cursor: pointer;
        font-size: 20px;
        margin: 5px 0;
        .a-img {
          width: 20px;
          height: 20px;
        }
      }
      .a-zhu{
        overflow: hidden;
        height: 30px;
        // white-space: nowrap;
        // text-overflow: ellipsis;
      }
    }
  }
  // 修改table的属性
  /deep/ #mygrid {
    width: 1029px;
    .ivu-table th {
      text-align: center;
      background: #e2e2e2;
    }
    .ivu-table td {
      text-align: center;
      height: 30px;
    }
  }
  .userP {
    color: #ccc;
    font-size: 14px;
    font-weight: 400;
    padding: 15px 0 0 61px;
  }

  .all {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 1000px;
    position: relative;

    .search {
      height: 52px;
      // margin: 20px 0 0 530px;
      position: absolute;
      top: 28px;
      left:533px;
      // left: 541px;
      .search_error {
        width: 120px;
        height: 30px;
        @include backgroundColor($_color);
        color: #fff;
        margin-left: 10px;
      }
      /deep/ .ivu-btn-error {
        border-color: #fff;
      }

      /deep/ .ivu-input {
        padding-left: 39px !important;
      }
      /deep/ .ivu-input::-webkit-input-placeholder {
        color: #999;
        padding-left: 30px;
      }
      img {
        position: absolute;
        left: 13px;
        top: 6px;
      }
    }
    .date {
      width: 1029px;
      margin: 30px 0 0 -9px;
      border: 1px solid #cccccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/pick.vue